import React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import styles from './dash-loading.module.css';

export class DashLoading extends React.Component {
    render() {
        return (
            <div className={styles['loading-lines-container']}>
                <LoadingIcon size={25} />
            </div>
        );
    }
}
